import { useQuery } from "react-query";

import { useApi } from "../../providers/ApiProvider";
import { APQueryOptions, useAPQuery } from "../../providers/APQueryProvider";
import { DossierQuoteSyncStatus } from "../../types/Quote";

export const getSyncQuotesStatus = (
  contactId: string,
  quoteId?: string,
  options: APQueryOptions = {}
) => {
  const { fetchWithAuth } = useApi();
  const {
    isQueryEnabled,
    defaultOnMutateSuccess,
    defaultOnMutateError,
    defaultOnMutateSettled,
  } = useAPQuery();
  const queryKey = ["syncQuotesStatus", contactId];

  return useQuery({
    queryKey,
    queryFn: (): Promise<DossierQuoteSyncStatus> => {
      return fetchWithAuth<DossierQuoteSyncStatus>(
        "getSyncQuotesStatus",
        contactId
      );
    },
    enabled: isQueryEnabled(options),
    onSettled: (data) => {
      if (data === "SYNCING") {
        setTimeout(() => {
          defaultOnMutateSettled([queryKey]);
        }, 5000);
      } else if (
        data === "SUCCESS" &&
        options.mutationOptions?.successAlertMessage
      ) {
        const invalidateList = [["quotes"], ["dossier"]];

        if (quoteId) {
          invalidateList.push(["list-quote", quoteId]);
          invalidateList.push(["quote", quoteId]);
          invalidateList.push(["quote-vehicle-suggestions", quoteId]);
          invalidateList.push(["quote-vehicle-images", quoteId]);
          invalidateList.push(["quote-vehicle-info", quoteId]);
          invalidateList.push(["quote-calculations", quoteId]);
          invalidateList.push([
            "quote-finance-comparison-calculations",
            quoteId,
          ]);
          invalidateList.push(["quote-finance-comparison", quoteId]);
        }

        const success = defaultOnMutateSuccess(options);
        success && success();
        defaultOnMutateSettled(invalidateList);
      } else if (options.mutationOptions?.errorAlertMessage) {
        const errorMessage = `${options.mutationOptions.errorAlertMessage}, Reason: ${data}`;

        const onError = defaultOnMutateError({
          ...options,
          mutationOptions: {
            ...options.mutationOptions,
            errorAlertMessage: errorMessage,
          },
        });

        onError();
      }
    },
  });
};
